module.exports = {"320829001":"高良涧街道","320829002":"朱坝街道","320829003":"黄集街道","320829101":"蒋坝镇","320829103":"岔河镇","320829104":"西顺河镇","320829105":"老子山镇","320829106":"三河镇","320829110":"东双沟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320829.json
// module id = 900
// module chunks = 0